module.exports = __webpack_public_path__ + "img/pause.622da5dc.svg";